import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, HostListener, OnInit, OnDestroy, PLATFORM_ID, Inject, AfterViewInit, ElementRef, ViewChild, Renderer2 } from '@angular/core';
import { LoginService } from '../../../features/login/service/login.service';
import { RouterModule, Router, NavigationEnd } from '@angular/router';
import { ReactiveFormsModule, FormBuilder } from '@angular/forms';
import { AuthService } from '../../../core/service/auth.service';
import { NotificationsService } from '../notifications/service/notifications.service';
import { SearchBarComponent } from '../search-bar/search-bar.component';
import { filter, take } from 'rxjs/operators';
import { ShopCartComponent } from '../shop-cart/shop-cart.component';
import { ShopCartService } from '../shop-cart/service/shop-cart.service';
import { Subscription } from 'rxjs';
import { ModalViewLocationComponent } from '../modal-view-location/modal-view-location.component';
import { ModalViewLocationService } from '../modal-view-location/service/modal-view-location.service';
import { SelectedAddressService } from '../../../core/service/selected-address.service';
import { Adresses } from '../modal-view-location/components/list-addresses/interfaces/addresses-user.interface';
import { CreateSlugService } from '../../../core/service/create-slug.service';
import { ModalConfirmLogoutComponent } from '../modal-confirm-logout/modal-confirm-logout.component';
import { ModalConfirmLogoutService } from '../modal-confirm-logout/service/modal-confirm-logout.service';
import { BalanceComponent } from "../balance/balance.component";
import { AnimationsService } from './services/animations.service';
import { ListAddressesUserService } from '../modal-view-location/components/list-addresses/service/list-addresses-user.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store/app.state';
import { setLocation } from '../../../store/location/location.actions';


@Component({
  selector: 'shared-header',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    SearchBarComponent,
    ShopCartComponent,
    ModalViewLocationComponent,
    ModalConfirmLogoutComponent,
    BalanceComponent
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
  standalone: true
})
export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {
  scrolled = false;
  isMobileMenuOpen = false;
  isLoggedIn = false;
  isHomePage = false;
  lg = false; // Variable para detectar si es pantalla grande (desktop)
  selectedAddress: Adresses | null = null;
  private authSubscription: Subscription | null = null;
  private addressSubscription: Subscription | null = null;
  private isBrowser: boolean;
  @ViewChild('logoImage', { static: false }) logoImage?: ElementRef<HTMLImageElement>;
  @ViewChild('logoWrapper', { static: false }) logoWrapper?: ElementRef<HTMLDivElement>;
  @ViewChild('logoShine', { static: false }) logoShine?: ElementRef<HTMLSpanElement>;
  private destroyHoverListener?: () => void;
  private destroyLeaveListener?: () => void;
  constructor(
    @Inject(PLATFORM_ID) platformId: Object,
    private fb: FormBuilder,
    private loginService: LoginService,
    private router: Router,
    private authService: AuthService,
    private notificationsService: NotificationsService,
    public cartService: ShopCartService,  // change to public
    public modalViewLocationService: ModalViewLocationService,
    public modalConfirmLogoutService: ModalConfirmLogoutService,
    private selectedAddressService: SelectedAddressService,
    private createSlugService: CreateSlugService,
    private renderer: Renderer2,
    private animations: AnimationsService,
    private listAddressesUserService: ListAddressesUserService,
    private store: Store<AppState>
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    // Initialize default values to prevent undefined errors
    this.scrolled = false;
    this.isHomePage = false;
    this.lg = false;
    this.isLoggedIn = false;
    this.selectedAddress = null;

    // Initialize scrolled state on component initialization
    this.checkScrollPosition();

    // Check screen size on initialization
    this.checkScreenSize();

    // Check initial auth state from service - both token and user
    this.isLoggedIn = this.authService.isLoggedIn() && !!this.authService.getUser();

    // Force update the auth state on component initialization
    setTimeout(() => {
      this.isLoggedIn = this.authService.isLoggedIn() && !!this.authService.getUser();
    }, 0);

    // Subscribe to authentication state changes
    this.authSubscription = this.authService.getCurrentUser().subscribe({
      next: (user) => {
        // Double check with both user and token for consistency
        this.isLoggedIn = !!user && this.authService.isLoggedIn();

        if (this.isLoggedIn && user) {
          this.checkAndSetDefaultAddress(user.ua_id);
        }

        // Force update all state when auth changes
        setTimeout(() => this.forceUpdateState(), 50);

        // If user is logged in, fetch cart items with error handling
        if (this.isLoggedIn) {
          this.cartService.getProductsApi().subscribe({
            next: (response) => {

            },
            error: (error) => {

              // No interrumpir el funcionamiento del header por errores del carrito
            }
          });
        }
      },
      error: (error) => {

        // Mantener el estado por defecto si hay error
        this.isLoggedIn = this.authService.isLoggedIn() && !!this.authService.getUser();
        this.forceUpdateState();
      }
    });

    // Subscribe to selected address changes with error handling
    this.addressSubscription = this.selectedAddressService.getSelectedAddress().subscribe({
      next: (address) => {

        this.selectedAddress = address;
      },
      error: (error) => {

        // Mantener la dirección actual o null si hay error
        this.selectedAddress = this.selectedAddressService.getCurrentSelectedAddress() || null;
      }
    });

    // Load initial selected address if available with error handling
    try {
      const initialAddress = this.selectedAddressService.getCurrentSelectedAddress();
      if (initialAddress) {

        this.selectedAddress = initialAddress;
      }
    } catch (error) {

      this.selectedAddress = null;
    }

    // Check initial route
    this.checkIfHomePage(this.router.url);

    // Subscribe to route changes
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.checkIfHomePage(event.url);

      // Re-check auth state on route change to ensure consistency
      setTimeout(() => this.forceUpdateState(), 100);
    });
  }

  ngAfterViewInit() {
    // Force update state after view initialization
    setTimeout(() => this.forceUpdateState(), 300);
    if (this.isBrowser) {
      setTimeout(() => {
        this.runIntroAnimation();
        this.setupHoverAnimation();
      }, 50);
    }
  }

  ngOnDestroy() {
    // Clean up subscriptions when component is destroyed
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
      this.authSubscription = null;
    }

    if (this.addressSubscription) {
      this.addressSubscription.unsubscribe();
      this.addressSubscription = null;
    }
    if (this.destroyHoverListener) { this.destroyHoverListener(); this.destroyHoverListener = undefined; }
    if (this.destroyLeaveListener) { this.destroyLeaveListener(); this.destroyLeaveListener = undefined; }
  }

  @HostListener('window:scroll')
  onWindowScroll() {
    this.checkScrollPosition();
    this.animateLogoOnScroll();
  }

  @HostListener('window:resize')
  onWindowResize() {
    this.checkScreenSize();
  }

  @HostListener('window:focus')
  onWindowFocus() {
    // Force update state when window gains focus (helps with page reload issues)
    this.forceUpdateState();
  }

  @HostListener('window:load')
  onWindowLoad() {
    // Force update state when page loads
    setTimeout(() => this.forceUpdateState(), 200);
  }

  checkAndSetDefaultAddress(userId: number) {
    const currentAddress = this.selectedAddressService.getCurrentSelectedAddress();
    if (!currentAddress) {
      this.listAddressesUserService.getAddresses(userId).pipe(take(1)).subscribe({
        next: (response) => {
          if (response.data && response.data.length > 0) {
            const firstAddress = response.data[0];
            this.selectAddress(firstAddress);
          }
        }
      });
    }
  }

  selectAddress(address: Adresses) {
    this.selectedAddressService.setSelectedAddress(address);
    const latitude = parseFloat(address.ad_latitude);
    const longitude = parseFloat(address.ad_longitude || '0');
    this.store.dispatch(setLocation({ latitude, longitude }));
  }

  // Helper method to check scroll position
  private checkScrollPosition() {
    if (!this.isBrowser) return;
    this.scrolled = window.scrollY > 0;
  }

  // Helper method to check screen size
  private checkScreenSize() {
    if (!this.isBrowser) return;
    this.lg = window.innerWidth >= 1024; // 1024px es el breakpoint de lg en Tailwind
  }

  // Helper method to check if current route is home page
  private checkIfHomePage(url: string): void {
    this.isHomePage = url === '/' || url === '';
  }

  // Helper method to force update component state
  private forceUpdateState(): void {
    this.isLoggedIn = this.authService.isLoggedIn() && !!this.authService.getUser();
    this.checkScrollPosition();
    this.checkScreenSize();
    this.checkIfHomePage(this.router.url);
  }

  private runIntroAnimation(): void {
    if (!this.isBrowser || !this.logoImage || !this.logoWrapper) return;
    const logoEl = this.logoImage.nativeElement;
    const wrapperEl = this.logoWrapper.nativeElement;
    const shineEl = this.logoShine?.nativeElement;
    this.animations.runIntroAnimation(logoEl, wrapperEl, shineEl);
  }

  private setupHoverAnimation(): void {
    if (!this.isBrowser || !this.logoImage) return;
    const logoEl = this.logoImage.nativeElement;
    const shineEl = this.logoShine?.nativeElement;
    this.destroyHoverListener = this.renderer.listen(logoEl, 'mouseenter', () => {
      this.animations.hoverEnter(logoEl);
      this.animations.runShineOnce(shineEl);
    });
    this.destroyLeaveListener = this.renderer.listen(logoEl, 'mouseleave', () => {
      this.animations.hoverLeave(logoEl);
    });
  }

  private animateLogoOnScroll(): void {
    if (!this.isBrowser || !this.logoImage) return;
    const logoEl = this.logoImage.nativeElement;
    this.animations.animateOnScroll(logoEl, this.scrolled);
  }

  toggleMobileMenu() {

    this.isMobileMenuOpen = !this.isMobileMenuOpen;

  }
  login(): void {
    if (this.isLoggedIn) {
      // Mostrar modal de confirmación de cierre de sesión
      this.modalConfirmLogoutService.toggleModal(true);
    } else {
      this.router.navigate(['/auth/login']).then(() => {
        // Force update state after navigation
        setTimeout(() => this.forceUpdateState(), 100);
      });
    }
  }

  logout(): void {
    this.loginService.logout().subscribe({
      next: () => {
        // Clear auth data
        this.authService.clearAuth();
        this.isLoggedIn = false;

        // Show success notification
        this.notificationsService.addNotification({
          message: 'Sesión cerrada exitosamente',
          type: 'success',
          duration: 3000
        });

        // Redirect to home page and force update state
        this.router.navigate(['/']).then(() => {
          setTimeout(() => this.forceUpdateState(), 100);
        });
      },
      error: (error) => {

        // Even if server returns an error, clear auth data on client side
        this.authService.clearAuth();
        this.isLoggedIn = false;

        // Show error notification
        this.notificationsService.addNotification({
          message: 'Error al cerrar sesión. Se ha cerrado la sesión localmente.',
          type: 'warning',
          duration: 5000
        });

        // Redirect to home page and force update state
        this.router.navigate(['/']).then(() => {
          setTimeout(() => this.forceUpdateState(), 100);
        });
      }
    });
  }

  openCart(): void {
    try {
      this.cartService.toggleCart(true);
    } catch (error) {
      // Mostrar notificación al usuario si es necesario
      this.notificationsService.addNotification({
        message: 'No se pudo abrir el carrito. Por favor, intenta de nuevo más tarde.',
        type: 'warning',
        duration: 3000
      });
    }
  }

  openLocationModal(): void {
    this.modalViewLocationService.toggleModal(true);
  }

  navigateToPerfil(): void {
    try {
      const user = this.authService.getUser();
      if (user && user.ua_name && user.ua_id) {
        const userSlug = this.createSlugService.createSlug(user.ua_name);
        this.router.navigate([`auth/perfil/${user.ua_id}/${userSlug}`]);
      } else {
        // Si no hay datos de usuario, redirigir a perfil básico
        this.router.navigate(['/auth/perfil']);
      }
    } catch (error) {
      // Fallback: navegar a perfil básico
      this.router.navigate(['/auth/perfil']);

      this.notificationsService.addNotification({
        message: 'Error al cargar el perfil. Redirigiendo a la página de perfil.',
        type: 'warning',
        duration: 3000
      });
    }
  }
}
